import React, { useEffect, useState } from "react";
import { LuBot } from "react-icons/lu";
import { Button, cn } from "../../components/ui";
import { t } from "../../i18n";

const STEPS = [t("newOrder.analyzing1"), t("newOrder.analyzing2"), t("newOrder.analyzing3")];

// Tela cheia enquanto a IA busca os procedimentos. As mensagens avançam até a última e param nela.
export const AnalyzingOverlay: React.FC<{ onCancel: () => void }> = ({ onCancel }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setStep((s) => Math.min(s + 1, STEPS.length - 1)), 2000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div role="status" className="fixed inset-0 z-50 grid animate-fade-in place-items-center bg-surface/95 px-4 backdrop-blur-sm">
      <div className="flex max-w-xs flex-col items-center gap-3.5 text-center">
        <div className="relative grid h-28 w-28 place-items-center">
          <span className="absolute inset-0 animate-spin rounded-full border-4 border-primary-soft border-t-primary" aria-hidden />
          <span className="absolute inset-3.5 rounded-full bg-primary-tint" aria-hidden />
          <LuBot size={54} className="relative text-primary" aria-hidden />
        </div>
        <p className="min-h-6 text-title-sm font-semibold" aria-live="polite">{STEPS[step]}</p>
        <div className="flex gap-1.5" aria-hidden>
          {STEPS.map((_, i) => (
            <i key={i} className={cn("h-2 w-2 rounded-full transition-colors duration-base", i <= step ? "bg-primary" : "bg-primary-line")} />
          ))}
        </div>
        <Button variant="outline" size="sm" onClick={onCancel} autoFocus>
          {t("common.cancel")}
        </Button>
      </div>
    </div>
  );
};
